import React from 'react'
import styles from './TwoCol.scss'
import cx from 'classnames'

export const ColWrap = ({className, ...props}) => (
  <div className={cx(styles.ColWrap, className)} {...props} />
)

export const MainCol = ({className, ...props}) => (
  <div className={cx(styles.MainCol, className)} {...props} />
)

export const SecondaryCol = ({className, ...props}) => (
  <div className={cx(styles.SecondaryCol, className)} {...props} />
)
